var _style, _polygon, _polygon2, _polygon3, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 188.1",
    style: {
      enableBackground: "new 0 0 1000 188.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000002346612231226020660000009285645039055793291_);}\n\t.st2{fill:#CCCCCC;}\n\t.st3{fill:url(#SVGID_00000137814215521907035880000016501584313156407450_);}\n\t.st4{fill:url(#SVGID_00000067229837416714036750000004483618041598035111_);}\n\t.st5{fill:#336699;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.346,
    y1: 79.6002,
    x2: 7.346,
    y2: 40.0411,
    gradientTransform: "matrix(1 0 0 -1 0 190)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFAB58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED4D58"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,110.4 14.7,150 0,150  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031195782461048147440000015237138179736991152_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.8938,
    y1: 112.6882,
    x2: 14.8938,
    y2: 40.0411,
    gradientTransform: "matrix(1 0 0 -1 0 190)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFAB58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED4D58"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031195782461048147440000015237138179736991152_)"
    },
    points: "29.8,150 21.7,150 0,95.6 0,77.4  0,77.3  "
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "47.8,130.7 21.2,56.2 34.8,56.2 34.9,56.7 47.8,98 60.7,56.7 60.8,56.2 74.4,56.2  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "95.3,56.2 55.8,150 39.8,150 0.3,56.2 13.7,56.2 46.2,140.2 49.4,140.2 82.9,56.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003087502336213765740000012405805643901535899_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.7034,
    y1: 112.6882,
    x2: 80.7034,
    y2: 40.0411,
    gradientTransform: "matrix(1 0 0 -1 0 190)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFAB58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED4D58"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000003087502336213765740000012405805643901535899_)"
    },
    points: "95.6,77.4 95.6,95.6 73.9,150  65.8,150 95.5,77.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008110870319847647920000008585146370367906980_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.5207,
    y1: 71.4754,
    x2: 98.6492,
    y2: 41.8045,
    gradientTransform: "matrix(1 0 0 -1 0 190)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EFAB58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED4D58"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008110870319847647920000008585146370367906980_)"
    },
    points: "80.9,150 95.6,110.4 95.6,150  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.9,
    y: 56.2,
    className: "st5",
    width: 1.4,
    height: 93.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209,100.1v24.1h-12.2v-22.2c0-6.8-3.1-9.9-8-9.9c-5.5,0-9.3,3.5-9.3,11v21.1h-12.2v-22.2c0-6.8-2.9-9.9-8-9.9 c-5.4,0-9.2,3.5-9.2,11v21.1H138v-42h11.6V87c3.1-3.6,7.8-5.5,13.2-5.5c5.9,0,10.9,2.3,13.8,6.8c3.7-4.5,9.3-7,15.2-6.8 C201.9,81.5,209,87.3,209,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.2,100.2v24h-11.4v-5.2c-2.3,3.8-6.6,5.9-12.8,5.9c-9.8,0-15.7-5.5-15.7-12.7c0-7.3,5.2-12.5,18-12.5h9.7 c0-5.2-3.1-8.3-9.7-8.3c-4.3,0-8.6,1.3-12.1,3.9l-4.4-8.5c4.6-3.3,11.4-5.1,18.1-5.1C249.8,81.5,257.2,87.5,257.2,100.2z  M245,110.9v-4.3h-8.4c-5.7,0-7.5,2.1-7.5,4.9c0,3,2.6,5.1,6.8,5.1C240.1,116.6,243.6,114.7,245,110.9L245,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M294.3,81.5v11.3c-1-0.1-1.8-0.2-2.7-0.2c-6.7,0-11.2,3.7-11.2,11.7v19.8h-12.2V82.1h11.6v5.5 C282.9,83.6,287.8,81.5,294.3,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M319.6,107.7l-5.9,5.8v10.7h-12.2v-58h12.2V99l17.8-16.9h14.5L328.6,100l19.1,24.2h-14.8L319.6,107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M394.2,66.2v58h-11.6v-4.8c-3.1,3.7-7.5,5.5-13.1,5.5c-11.9,0-21-8.4-21-21.6s9.1-21.6,21-21.6 c5.1,0,9.5,1.6,12.5,5.1V66.2H394.2z M382.2,103.2c0-7.3-4.7-11.6-10.7-11.6s-10.8,4.4-10.8,11.6s4.7,11.6,10.8,11.6 S382.2,110.4,382.2,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M402.3,103.2c0-12.7,9.8-21.6,23.1-21.6c13.4,0,23,9,23,21.6s-9.7,21.6-23,21.6S402.3,115.8,402.3,103.2z  M436.1,103.2c0-7.3-4.6-11.6-10.7-11.6s-10.8,4.4-10.8,11.6s4.7,11.6,10.8,11.6S436.1,110.4,436.1,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M522.9,82.1l-15.2,42H496l-9.5-26.1l-9.8,26.1h-11.7l-15.2-42h11.5l9.9,28.5l10.2-28.5h10.3l10,28.5l10.2-28.5 H522.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M571.6,100.1v24.1h-12.2v-22.2c0-6.8-3.1-9.9-8.5-9.9c-5.9,0-10.1,3.6-10.1,11.4v20.8h-12.2v-42h11.6v4.9 c3.3-3.6,8.2-5.5,13.9-5.5C564.2,81.5,571.6,87.3,571.6,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M609.8,122.1c-3,1.9-6.4,2.8-9.9,2.7c-9.9,0-15.7-5.1-15.7-15.1V92.5h-6.5v-9.4h6.5V72.8h12.2v10.2h10.5v9.4 h-10.5v17.1c0,3.6,1.9,5.5,5.2,5.5c1.8,0,3.5-0.5,4.9-1.6L609.8,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M612.2,103.2c0-12.7,9.8-21.6,23.1-21.6s23,9,23,21.6s-9.7,21.6-23,21.6S612.2,115.8,612.2,103.2z M646,103.2 c0-7.3-4.6-11.6-10.7-11.6s-10.8,4.4-10.8,11.6s4.7,11.6,10.8,11.6S646,110.4,646,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M709.3,66.2v58h-11.6v-4.8c-3,3.7-7.5,5.5-13.1,5.5c-11.9,0-21-8.4-21-21.6s9.1-21.6,21-21.6 c5.2,0,9.5,1.6,12.5,5.1V66.2H709.3z M697.4,103.2c0-7.3-4.7-11.6-10.7-11.6s-10.8,4.4-10.8,11.6s4.7,11.6,10.8,11.6 S697.4,110.4,697.4,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M757.8,100.2v24h-11.4v-5.2c-2.3,3.8-6.6,5.9-12.8,5.9c-9.8,0-15.7-5.5-15.7-12.7c0-7.3,5.2-12.5,18-12.5h9.7 c0-5.2-3.1-8.3-9.7-8.3c-4.3,0-8.6,1.3-12.1,3.9l-4.4-8.5c4.6-3.3,11.4-5.1,18.1-5.1C750.4,81.5,757.8,87.5,757.8,100.2z  M745.6,110.9v-4.3h-8.3c-5.7,0-7.5,2.1-7.5,4.9c0,3,2.6,5.1,6.8,5.1C740.7,116.6,744.2,114.7,745.6,110.9L745.6,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M809.7,82.1l-18.9,44.6c-4.1,10.2-9.8,13.2-17.4,13.2c-4.3,0-9-1.4-11.7-3.8l4.5-8.7c1.9,1.7,4.3,2.6,6.8,2.7 c3.4,0,5.2-1.5,6.8-5.2l0.2-0.4l-18.2-42.3h12.5l11.8,28.5l11.9-28.5L809.7,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M809.3,117.1c0-4.2,3.4-7.6,7.6-7.6c4.2,0,7.6,3.4,7.6,7.6c0,4.2-3.4,7.6-7.6,7.6S809.3,121.3,809.3,117.1 C809.3,117.2,809.3,117.1,809.3,117.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M829.1,103.2c0-12.7,9.8-21.6,23.4-21.6c8.8,0,15.8,3.8,18.8,10.7l-9.5,5.1c-1.8-3.6-5.5-5.8-9.5-5.8 c-6.2,0-11,4.3-11,11.6s4.8,11.6,11,11.6c4,0.1,7.7-2.2,9.5-5.8l9.5,5.2c-3.1,6.7-10,10.6-18.8,10.6 C838.8,124.8,829.1,115.8,829.1,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M874.7,103.2c0-12.7,9.8-21.6,23.1-21.6c13.4,0,23,9,23,21.6s-9.7,21.6-23,21.6 C884.5,124.8,874.7,115.8,874.7,103.2z M908.5,103.2c0-7.3-4.6-11.6-10.7-11.6c-6.1,0-10.8,4.4-10.8,11.6s4.7,11.6,10.8,11.6 C903.9,114.8,908.5,110.4,908.5,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1000,100.1v24.1h-12.2v-22.2c0-6.8-3-9.9-8-9.9c-5.5,0-9.3,3.5-9.3,11v21.1h-12.2v-22.2c0-6.8-2.9-9.9-8-9.9 c-5.4,0-9.2,3.5-9.2,11v21.1H929v-42h11.6V87c3.1-3.6,7.8-5.5,13.2-5.5c5.9,0,10.9,2.3,13.8,6.8c3.7-4.5,9.3-7,15.2-6.8 C992.8,81.5,1000,87.3,1000,100.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b634a402fc8432811c9f858f80a2a06.svg";
export { ForwardRef as ReactComponent };